import { styled } from '@abyss/web/tools/styled';

export const StyledFAQContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '24px',
});

export const OnboardingHeading = styled('h2', {
  fontSize: '32.45px !important',
  fontFamily: '$heading',
  lineHeight: '40px !important',
  '&.abyss-heading-root': {
    fontFamily: '$heading',
    fontWeight: '$semibold',
  },
});
